import * as React from "react";
import clsx from "clsx";
import { InputProps } from ".";

const Input: React.FC<InputProps> = ({
    value = "",
    label = "",
    labelContent = () => {},
    wrapper = {},
    classes = {},
    input = {},
    iconBeforeContainer = {},
    iconAfterContainer = {},
    loading,
    disabled,
    placeholder,
    inputComponent,
    ...props
}) => {
    props.iconAfter = props.iconAfter ? props.iconAfter : props.icon_after;
    props.iconBefore = props.iconBefore ? props.iconBefore : props.icon_before;
    props.errorMessage = props.errorMessage
        ? props.errorMessage
        : props.error_message || props.error?.message;
    props.successMessage = props.successMessage ? props.successMessage : props.success_message;

    const onChange = (e) => {
        if (props.onChange) {
            props.onChange(e);
        }
    };

    //prevent infinite loop
    const onKeyUp = input.onKeyUp;

    const onKeyUpEnter = (e) => {
        if (onKeyUp) {
            onKeyUp(e);
        }

        if (e.key === "Enter" && props.action) {
            props.action();
        }
    };

    if (props.errorMessage) {
        classes.input_container = clsx("tmp-input-error", classes.input_container);
    }

    input["data-name"] = props.name;

    if (!input.type) {
        input.type = "text";
    }

    input.onKeyUp = onKeyUpEnter;

    const input_styles: any = {};

    if (props.iconBefore) {
        input_styles.paddingLeft = 0;
    }

    if (props.iconAfter) {
        input_styles.paddingRight = 0;
    }

    if (input_styles) {
        if (input.style) {
            input.style = { ...input_styles, ...input.style };
        } else {
            input.style = input_styles;
        }
    }

    iconBeforeContainer.className = clsx("tmp-input-icon-container", iconBeforeContainer.className);

    iconAfterContainer.className = clsx("tmp-input-icon-container", iconAfterContainer.className);

    const InputComp = (inputComponent as any) ?? "input";

    return (
        <label className={clsx(classes.wrapper, "tmp-label")} {...wrapper}>
            <div className="tmp-label-text">
                {label}
                {labelContent()}
            </div>
            <div
                className={clsx(classes.input_container, "tmp-input-container", {
                    "tmp-disabled": disabled,
                })}
            >
                {props.iconBefore && typeof props.iconBefore === "string" && (
                    <div {...iconBeforeContainer}>
                        <i className={props.iconBefore} />
                    </div>
                )}
                {props.iconBefore && typeof props.iconBefore !== "string" && props.iconBefore}
                <InputComp
                    {...input}
                    className={clsx(classes.input, input?.className, "tmp-input")}
                    value={value}
                    onChange={onChange}
                    disabled={disabled || input.disabled}
                    readOnly={loading || input.readOnly}
                    placeholder={placeholder || input.placeholder}
                />
                {loading ? (
                    <div {...iconAfterContainer}>
                        <i className="fas fa-spinner fa-pulse" />
                    </div>
                ) : (
                    <>
                        {props.iconAfter && typeof props.iconAfter === "string" && (
                            <div {...iconAfterContainer}>
                                <i className={props.iconAfter} />
                            </div>
                        )}
                        {props.iconAfter && typeof props.iconAfter !== "string" && props.iconAfter}
                    </>
                )}
            </div>
            {props.errorMessage ? (
                <div className="tmp-input-error-message">{props.errorMessage}</div>
            ) : null}
            {props.successMessage ? (
                <div className="tmp-input-success-message">{props.successMessage}</div>
            ) : null}
        </label>
    );
};

export default Input;
